import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CachingApiService } from '@services/core-services/api-cache.service';
import { ExportDataResponse } from './models/export-data-response';
import { ExportData } from './models/export-data.modal';
import { PaginatedList } from './models/paginated-list';
import { Query } from './models/query';
import { ErrorHandlerService } from '@services/core-services/error-handler.service';
import { exportDataSource } from '@services/core-services/constants/export-data-sources';
import { ExportDataFilters } from '@services/core-services/constants/export-data-filters';

@Injectable({
  providedIn: 'root',
})
export class ExportDataService {
  constructor(
    private readonly cacheApi: CachingApiService,
    private readonly errorHandler: ErrorHandlerService
  ) {}

  exportData(
    data_source: exportDataSource,
    data_filters: ExportDataFilters
  ): Observable<ExportData> {
    const url = `store/downloads`;
    const payload = {
      data_source,
      data_filters: {
        condition: 'AND',
        filters: data_filters,
      },
    };

    return this.cacheApi.post<any, ExportDataResponse>(url, payload).pipe(
      map((response: ExportDataResponse) => response.content.exports),
      catchError(err => this.errorHandler.handleAndNotify(err, 'Failed to start export'))
    );
  }

  downloadDataList(query?: Query): Observable<PaginatedList<ExportData[]>> {
    const urlId = `store/downloads`;
    return this.cacheApi.getWithCache<ExportDataResponse>(urlId, query).pipe(
      map((response: ExportDataResponse) => ({
        list: response.content.exports || [],
        pagination: response.content.pagination,
      }))
    );
  }
}
